<template>
    <div class="app">
<section v-show="personalInfoShow">
    <div class="personal-info">
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">个人信息</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div class="minContent">
                <ul>
                    <li class="item" @click="goTouxiangPage">
                        <span>头像</span>
                        <img :src="avatar" alt="">
                        <i class="el-icon-arrow-right"></i>
                    </li>
                    <li class="item" @click="goNickPage">
                        <span>昵称</span>
                        <span v-if="nick == ''" class="placeholder">请填写昵称</span>
                        <span v-if="nick != ''">{{ nick }}</span>
                        <i class="el-icon-arrow-right"></i>
                    </li>
                    <li class="item" @click="goIdentityPage">
                        <span>身份证</span>
                        <span>{{identity == '' ? '未认证' : identity}}</span>
                        <i class="el-icon-arrow-right"></i>
                    </li>
                    <li class="item" @click="openPicker">
                        <span>生日</span>
                        <span>{{birthday == '' ? '请选择' : birthday}}</span>
                        <i class="el-icon-arrow-right"></i>
                    </li>
                    <li class="item" @click="selectSex">
                        <span>性别</span>
                        <span>{{sex == '' ? '请选择' : sex}}</span>
                        <i class="el-icon-arrow-right"></i>
                    </li>
                    <li class="item" @click="goAddrPage">
                        <span>地址</span>
                        <span v-if="address == ''" class="placeholder">请填写地址</span>
                        <span v-if="address != ''">{{ address }}</span>
                        <i class="el-icon-arrow-right"></i>
                    </li>
                    <li class="item" @click="goSignPage">
                        <span>签名</span>
                        <span>{{sign == '' ? '最多16个字' :sign}}</span>
                        <i class="el-icon-arrow-right"></i>
                    </li>
                </ul>
            </div>
        </div>
        <!-- 日期弹框 -->
        <mt-datetime-picker
            ref="picker"
            type="date"
            v-model="value4"
            year-format="{value}"
            month-format="{value}"
            date-format="{value}"
            :startDate = "startDate"
            :endDate = "endDate"
            @confirm="handleChange">
        </mt-datetime-picker>
        <div :class="isShow ? 'tip' : 'tip1'">
            <div class="msgBox">
                <div class="sex">性别</div>
                <div class="male" @click="selectmale">
                    <img v-if="isSelected" src="../../assets/images/radio.png" alt="">
                    <img v-if="!isSelected" src="../../assets/images/radio_S.png" alt="">
                    &nbsp;&nbsp;<span>男</span>
                    <!-- <input type="radio" checked name="男"> -->
                    <!-- <img :src="isSelected ? '../../assets/images/radio.png' : '../../assets/images/radio_S.png'" alt=""> -->
                </div>
                <div class="female" @click="selectfemale">
                    <img v-if="!isSelected" src="../../assets/images/radio.png" alt="">
                    <img v-if="isSelected" src="../../assets/images/radio_S.png" alt="">
                    &nbsp;&nbsp;<span>女</span>
                    <!-- <input type="radio" name="女"> -->
                    <!-- <img :src="!isSelected ? '../../assets/images/radio.png' : '../../assets/images/radio_S.png'" alt=""> -->
                </div>
            </div>
        </div>
        </div>
    </section>
    <section v-if="isNickPageShow">
        <text-field-page :ptitle="nickTitle" :pvalue="nick" :pplaceholder="nickHint" @closePage="closePage" @saveValue="updateNick"></text-field-page>
    </section>
    <section v-if="isAddrPageShow">
        <text-field-page :ptitle="addrTitle" :pvalue="address" :pplaceholder="addrHint" @closePage="closePage" @saveValue="updateAddr"></text-field-page>
    </section>
    </div>
</template>
<script>
import { Toast,Popup,DatetimePicker ,Picker } from 'mint-ui';
import { MessageBox } from 'element-ui';
import { getUserInfoLocalStorage, setUserInfoLocalStorage } from "../../assets/js/localStorage"
import { showUserAction, updateUserAction } from '../../assets/js/api'
import avatarDefault from '@/assets/images/thstart.png'
import textFieldPage from '@/components/elements/textFieldPage'

export default {
  name: 'personalInformation',
  data() {
    return {
          avatar: '',
          sex:'',
          nick:'',
          birthday:'',
          identity:'',
          address: '',
          sign:'',
          isShow:false,
          isSelected:false,
          value4:null,
          startDate:new Date(new Date().getFullYear()-100,0,1),
          endDate:new Date(new Date().getFullYear(),11,31),
          userInfo: null,
          personalInfoShow: true,
          isNickPageShow: false,
          nickTitle: '修改昵称',
          nickHint: '请填写昵称',
          isAddrPageShow: false,
          addrTitle: '修改地址',
          addrHint: '请填写地址'
    };
  },
  filters:{},
  computed: {},
  components: {
      'text-field-page': textFieldPage
  },
  methods: {  
      //跳转头像页面
      goTouxiangPage(){
          this.$router.push({name:"touxiang"})
      },
      // 显示昵称页面
      goNickPage () {
          this.personalInfoShow = false
          this.isNickPageShow = true
      },
      goAddrPage () {
          this.personalInfoShow = false
          this.isAddrPageShow = true
      },
      closePage () {
          this.personalInfoShow = true
          this.isNickPageShow = false
          this.isAddrPageShow = false
      },
      updateNick (nick) {
          if (this.nick != nick) {
            this.nick = nick
            this.save()
          }
      },
      updateAddr (addr) {
          if (this.address != addr) {
            this.address = addr
            this.save()
          }
      },
      //跳转身份认证页面
      goIdentityPage(){
          this.$router.push({name:"identity"})
      },
      //跳转签名页面
      goSignPage(){
          this.$router.push({name:"sign", query: {signContent: this.sign}})
      },
      // 显示存储的个人信息
      showLocalUserInfo () {
          this.userInfo = JSON.parse(getUserInfoLocalStorage())
          
          if (this.userInfo) {
            this.updateUI()
          }
      },
      //获取个人信息
      getUserInfo(){
          showUserAction().then (res => {
              if (res.s == 0) {
                if (res.user) {
                    var user = res.user
                    this.userInfo.sex = user.sex ? user.sex : 0
                    this.userInfo.avatar = user.avatar ? user.avatar : ''
                    this.userInfo.nick = user.nick ? user.nick : ''
                    this.userInfo.address = user.address ? user.address : ''
                    this.userInfo.info = user.info ? user.info : ''
                    this.userInfo.birthday = user.birthday ? user.birthday : ''
                    this.userInfo.identity = user.identity ? user.identity : ''

                    setUserInfoLocalStorage(JSON.stringify(this.userInfo))
                    this.updateUI()
                }
              }
          })
      },
      /**
       * 更新界面数据
       */ 
      updateUI () {
        this.avatar = (this.userInfo.avatar !== '' && this.userInfo.avatar != '1' && this.userInfo.avatar != '0') ? this.userInfo.avatar : avatarDefault
        this.nick = this.userInfo.nick
        this.identity = this.userInfo.identity
        this.birthday = this.userInfo.birthday
        this.value4 = this.formatDate(this.birthday)
        this.sex = (this.userInfo.sex == 0) ? '男' : '女'
        this.sign = this.userInfo.info
        this.address = this.userInfo.address
      },
      //日期选择
      openPicker(){
          this.$refs.picker.open();
      },
      handleChange(value){
          console.log(value, this.birthday);
          let date = this.formatDate(value)
          if (date != this.birthday) {
              this.birthday = date
              this.save()
          }
      },
      formatDate (value) {
          var date = new Date(value);
          var y = date.getFullYear();
          var m = date.getMonth() + 1;
          var d = date.getDate();
          if (m < 10) { m = '0' + m }
          if (d < 10) { d = '0' + d }
          return y + '-' + m + '-' + d
      },
      //性别选择
      selectSex(){
          this.isShow = true;
      },
      selectmale(){
          if (this.sex != '男') {
            this.sex = "男";
            this.save()
          }
          this.isSelected = false;
          this.isShow = false;
      },
      selectfemale(){
          if (this.sex != '女') {
            this.sex = "女";
            this.save()
          }
          this.isSelected = true;
          this.isShow = false;
      },
      //保存用户信息
      save(){
          // 更新项：昵称、生日、性别、地址
          var sex = (this.sex == "女") ? 1 : 0
          updateUserAction(sex, null, this.nick, this.address, null, this.birthday, null)
          .then(res => {
              console.log(res);
              if (res.s == 0) {
                Toast:Toast({
                    message:'保存成功',
                    position:'middle',
                    duration: 2500,
                })
                this.getUserInfo()
              }
          })
          .catch(err => {
              Toast:Toast({
                  message:'网络不给力，请稍后重试',
                  position:'middle',
                  duration: 2500,
              })
          })
      }
  },
  mounted(){
      this.avatar = avatarDefault
      this.showLocalUserInfo()
  }
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 38%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  background-color: rgba(241, 241, 241, 1);
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}
i.el-icon-arrow-right{
    float: right;
    color: rgba(0, 0, 0, 0.8);
    font-size: 0.55rem
}
.minContent{
    background-color: #fff;
    margin-top: 0.2rem;
}
.item{
    font-size: 0.42rem;
    color: rgba(0, 0, 0,0.7);
    line-height: 1.29rem;
    width: 94%;
    height: 1.29rem;
    margin-left: 0.61rem;
    border-bottom: 0.03rem solid rgba(0, 0, 0,0.1);
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
}
.item :nth-child(2){
    flex-grow: 1;
    margin-right: .33rem;
    text-align: right;
}
.item :nth-child(3){
    flex-basis: 10%;
}
.minContent ul :first-child{
    height: 1.45rem;
    line-height: 1.45rem;
    justify-content: flex-end;
}
.minContent ul :first-child :nth-child(1){
    flex-grow: 1;
    text-align: left;   
}
.minContent ul :first-child :nth-child(2){
    flex-grow: 0;
    height: 1.32rem;
    width: 1.32rem;
}
.minContent ul :first-child :nth-child(3){
    flex-basis: 10%;
}
input[type=text] {
    border: none;
    text-align: right;
    position: absolute;
    padding-top: 0.15rem;
}
.button{
    width: 6.71rem;
    height: 1.05rem;
    background-color: rgba(41, 158, 173, 1);
    text-align: center;
    color: #fff;
    font-size: 0.42rem;
    border-radius: 0.16rem;
    position: relative;
    left: 15%;
    top: 0.79rem;
}
.tip{
    text-align: center;
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(187, 187, 187, 0.61);
    z-index: 9999;
}
.tip1{
    display: none;
}
.msgBox{
    width: 5.61rem;
    height: 3.39rem;
    background-color: #fff;
    border: 0.03rem solid rgba(255,255,255,0);
    position: fixed;
    top: 30%;
    left: 20%;
}
.sex{
    text-align: left;
    font-size: 0.37rem;
    color: rgba(16, 16, 16, 1);
    line-height: 0.53rem;
    margin-top: 0.32rem;
    margin-left: 0.47rem;
}
.male{
    width: 2.71rem;
    font-size: 0.37rem;
    margin-top: 0.4rem;
    margin-left: 1.24rem;
    padding-bottom: 0.2rem;
    line-height: 0.53rem;
    text-align: justify;
    border-bottom: 0.03rem solid rgba(0, 0, 0,0.1);
}
.female{
    width: 2.71rem;
    font-size: 0.37rem;
    margin-left: 1.24rem;
    line-height: 0.53rem;
    text-align: justify;
    padding-top: 0.2rem;
}
.male img,
.female img{
    width: 0.26rem;
    height: 0.26rem;
}
.placeholder {
    font-style: italic;
    color: rgba(187, 187, 187, 0.61);
}
</style>



// WEBPACK FOOTER //
// src/components/mine/personalInformation.vue